// Action Types
export const SET_FEATURED_STREAMERS = 'FEATURED_STREAMERS/SET_FEATURED_STREAMERS';
export const SET_IS_LOADING = 'FEATURED_STREAMERS/SET_IS_LOADING';

// Action Creator
const FeaturedStreamersActionCreator = {
  setFeaturedStreamers(type: string, streamers: any) {
    return {
      type: SET_FEATURED_STREAMERS,
      payload: {
        type,
        data: streamers
      }
    };
  },

  setIsLoading(type: string, isLoading: boolean) {
    return {
      type: SET_IS_LOADING,
      payload: {
        type,
        isLoading
      }
    };
  }
};

export default FeaturedStreamersActionCreator;
